'use client';

import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const CommitIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  width: 100%;
  gap: 50px;
`;

const CommitSection = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  .commitRef {
    font-family: monospace;
  }

  .lastCommit {
    color: ${colors.secondary.mediumGray};
  }

  .message {
    color: ${colors.secondary.mediumGray};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media (max-width: ${breakPoints.mobile}) {
    .commitRef,
    .message {
      display: none;
    }
  }
`;

export const CommitDetails = styled(CommitSection)`
  min-width: 0;
  width: 100%;
`;

export const CommitHistory = styled(CommitSection)`
  font-size: 12px;
  white-space: nowrap;
  & > a > * {
    display: block;
  }
`;

export const TightRow = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  white-space: nowrap;
  & > a > * {
    display: block;
  }
`;
